module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_pending_request-db4d4682ff081c81dc77dcfa74884739.svg";